import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ets-sso-invalid',
  templateUrl: './sso-invalid.component.html',
  styleUrls: ['./sso-invalid.component.scss']
})
export class SsoInvalidComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
